import { WarningOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { COLORS, computeRemSize } from '@ydistri/theme';
import { css, styled } from 'styled-components';

export const SectionContainer = styled.div`
  padding: ${computeRemSize(8)};
`;

export const AddRuleRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${computeRemSize(8)};
`;

export const AddRuleLabel = styled.span`
  white-space: nowrap;
`;

export const AddRuleControl = styled.div`
  width: 100%;
  max-width: ${computeRemSize(320)};

  .ant-select {
    width: 100%;
  }
`;

export const ValueSelectControl = styled.div`
  .ant-select {
    width: 100%;
  }
`;

export const RuleLabel = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${computeRemSize(2)};
`;

export const RuleLabelHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${computeRemSize(4)};
`;

export const RuleWarningIcon = styled(WarningOutlined)`
  color: ${COLORS.WEB_ORANGE_HOVER};
  font-size: ${computeRemSize(16)};
`;

export const RuleSelectionCount = styled.button`
  border: 0;
  padding: 0;
  background: transparent;
  color: ${COLORS.GREY};
  cursor: pointer;
  font-family: inherit;
  font-size: ${computeRemSize(10)};
  line-height: 1.2;
  text-align: left;
  text-decoration: underline;
`;

export const RulesTableOverflow = styled.div`
  overflow-x: auto;
`;

export const RulesTable = styled.table`
  width: 100%;
  min-width: ${computeRemSize(480)};
  border-collapse: collapse;
  table-layout: fixed;

  td {
    padding: ${computeRemSize(4)};
    text-align: left;
    vertical-align: middle;
  }

  td:first-child {
    width: ${computeRemSize(76)};
    vertical-align: top;
  }

  td:nth-child(2) {
    width: ${computeRemSize(92)};
    vertical-align: top;
  }

  td:last-child {
    width: ${computeRemSize(32)};
  }
`;

export const RuleRow = styled.tr<{ $hasWarning: boolean }>`
  ${({ $hasWarning }) =>
    $hasWarning &&
    css`
      background-color: ${COLORS.TABLE_HIGHLIGHT_ORANGE};
    `}
`;

export const ExclusionControl = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${computeRemSize(2)};
`;

export const ExclusionLabel = styled.span`
  color: ${COLORS.DANGER};
  font-size: ${computeRemSize(10)};
  line-height: 1.2;
  white-space: nowrap;
`;

export const ExclusionButton = styled(Button)<{ $isExcluded?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${computeRemSize(24)};
  min-width: ${computeRemSize(24)};
  height: ${computeRemSize(24)};
  padding: 0;

  ${({ $isExcluded }) =>
    $isExcluded &&
    css`
      &.ant-btn,
      &.ant-btn:hover,
      &.ant-btn:focus {
        color: ${COLORS.WHITE};
        background-color: ${COLORS.DANGER};
        border-color: ${COLORS.DANGER};
      }
    `}
`;
